import Plyr from "plyr";

if (document.querySelector(".vimeo-iframe")) {
    const videoEls = document.querySelectorAll(".vimeo-iframe");

    videoEls.forEach((videoEl, index) => {
        initPlyr(videoEl);
    });
}

function initPlyr(iframe) {
    const container = iframe.parentElement;
    iframe.src = iframe.dataset.src;

    const player = new Plyr(container, {
        vimeo: {
            dnt: true,
            controls: 0,
            background: 1,
        },
        settings: ["captions", "quality", "speed", "loop"],
        loadSprite: false,
        iconUrl: "/site/templates/images/plyr.svg",
    });
}
